import { Room } from './room.model';
export class Location {
  id: string;
  medicalPracticeId: string;
  companyName: string;
  name: string;
  officeAddress: string;
  city: string;
  postalCode: string;
  isDefault: boolean = false;
  rooms: Room[];

  constructor(name?: string) {
      this.name = name;
      this.rooms = [];
      if (name) {
        this.companyName = '';
        this.officeAddress = '';
        this.city = '';
        this.postalCode = '';
        this.rooms.push(new Room('Ma pièce'));
      }
  }
}
